export default function ChildrenGifts() {
  return (
    <section id="gifts" className="relative py-28 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/81a6bd0193884e748edd76217c26088d.jpg"
          alt="Party celebration background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#E2D9CA]/95 via-[#E2D9CA]/80 to-[#E2D9CA]/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-[#EB9830] rounded-full"></span>
              <span className="text-sm uppercase tracking-wider text-[#EB9830] font-semibold">
                CELEBRATE IN STYLE
              </span>
            </div>

            <h2 className="text-5xl font-serif text-[#574407] leading-tight">
              Delightful Party Bags for Every Occasion
            </h2>

            <p className="text-base text-[#936A0B] leading-relaxed">
              From birthday bashes to baby showers, our handpicked party bags and
              gift souvenirs make every celebration magical. Each bag is
              thoughtfully assembled with quality treats, fun surprises, and
              beautiful packaging that kids absolutely love.
            </p>

            <div className="grid grid-cols-3 gap-6 pt-4">
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#EB9830]/10 rounded-full">
                  <i className="ri-gift-line text-xl text-[#EB9830]"></i>
                </div>
                <p className="text-xs text-[#574407] font-medium">Custom Themes</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#EB9830]/10 rounded-full">
                  <i className="ri-heart-line text-xl text-[#EB9830]"></i>
                </div>
                <p className="text-xs text-[#574407] font-medium">Made with Love</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#EB9830]/10 rounded-full">
                  <i className="ri-star-line text-xl text-[#EB9830]"></i>
                </div>
                <p className="text-xs text-[#574407] font-medium">Premium Quality</p>
              </div>
            </div>

            <a
              href="#party-bags"
              className="inline-block px-10 py-4 bg-[#574407] text-white text-base font-medium rounded-full hover:bg-[#936A0B] transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Browse Party Bags
            </a>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl w-full h-[480px]">
              <img
                src="https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/3feeb52f89a135bf053eb266929a34a3.jpeg"
                alt="ABEXIA Children's Party Bags Collection - Frosted gift bags with elegant ring handles and satin bows"
                title="ABEXIA Party Bags for Kids"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-[#EB9830] text-white px-6 py-3 rounded-2xl shadow-lg">
              <p className="text-sm font-bold">50+ Designs</p>
              <p className="text-xs opacity-90">For every theme</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}